type LocalStorageOneFromKey = "actionPlan-main-tabs" | "actionPlan-trajectory-tabs" | "actionPlan-planning-tabs";

const actionPlanMainTabs = ["trajectory", "planning"] as const;
export type ActionPlanMainTabs = (typeof actionPlanMainTabs)[number];

const actionPlanTrajectoryTabs = ["barChart", "cards"] as const;
export type ActionPlanTrajectoryTabs = (typeof actionPlanTrajectoryTabs)[number];

const actionPlanPlanningTabs = ["list", "preview"] as const;
export type ActionPlanPlanningTabs = (typeof actionPlanPlanningTabs)[number];

export const oneOfConfiguration = {
    "actionPlan-main-tabs": {
        values: actionPlanMainTabs,
        default: actionPlanMainTabs[0],
    },
    "actionPlan-trajectory-tabs": {
        values: actionPlanTrajectoryTabs,
        default: actionPlanTrajectoryTabs[0],
    },
    "actionPlan-planning-tabs": {
        values: actionPlanPlanningTabs,
        default: actionPlanPlanningTabs[0],
    },
};

type AllConfigurationValues<T extends LocalStorageOneFromKey> = (typeof oneOfConfiguration)[T]["values"][number];

export class OneInLocalStorage {
    static getItem<T extends LocalStorageOneFromKey>(key: T): AllConfigurationValues<T> {
        const config = oneOfConfiguration[key];
        const item = localStorage.getItem(key);

        if (item === null) {
            localStorage.setItem(key, config.default);
            return config.default;
        }

        const existingItem = config.values.find((i) => i === item);
        const isItemDeprecated = existingItem === undefined;
        if (isItemDeprecated) {
            localStorage.setItem(key, config.default);
            return config.default;
        }
        return existingItem;
    }

    static setItem<T extends LocalStorageOneFromKey>(key: T, value: AllConfigurationValues<T>): void {
        localStorage.setItem(key, value);
        return;
    }

    static deleteItem(key: LocalStorageOneFromKey) {
        localStorage.removeItem(key);
    }
}
